/* eslint-disable react/jsx-props-no-spreading */
import React, { cloneElement } from 'react';
import { QueryProvider } from '../react/QueryProvider';

/**
 *
 * @param {*} WrappedComponent
 * @param {*} props QueryProvider props
 */
export const withQueryProvider = (WrappedComponent, props) => {
  // eslint-disable-next-line react/jsx-props-no-spreading
  const WrappedClone = (wrappedProps) => <WrappedComponent {...wrappedProps} />;
  WrappedClone.wraps = WrappedComponent.wraps || {};
  WrappedClone.dataModel = WrappedComponent.dataModel;
  WrappedClone.propTypes = WrappedComponent.propTypes;
  WrappedClone.displayName = WrappedComponent.displayName;
  WrappedClone.defaultProps = WrappedComponent.defaultProps;
  const Component = ({ children, ...wrappedComponentProps }) => {
    const queryProviderProps = props || {};

    if (queryProviderProps.defaultVariables) {
      queryProviderProps.defaultVariables = wrappedComponentProps?.qctx?.defaultVariables?.current || null;
    }

    return (
      <QueryProvider
        {...queryProviderProps}
      >
        <WrappedClone {...wrappedComponentProps}>
          {children}
        </WrappedClone>
      </QueryProvider>
    );
  };
  Component.propTypes = WrappedComponent.propTypes;
  Component.defaultProps = WrappedComponent.defaultProps;

  Component.displayName = WrappedComponent.displayName || 'QueryProvider';
  Component.wraps = {
    ...(WrappedComponent.wraps || {}),
    queryProvider: true,
  };

  return Component;
};
